module.exports = __webpack_public_path__ + "static/media/fen.e2486d01.svg";